import React, { useMemo, useState } from 'react'
import { motion } from 'framer-motion'
import * as portals from 'react-reverse-portal'
import FiltersContext from '../../../components/Filters/FiltersContext'
import { Info, RadioInput, Table } from '@demandlocal/components'
import { useGetIntegrations } from '../../../api/admin/useGetIntegrations'
import { Integration } from '../../../lib/types/Integration'
import { createColumnHelper } from '@tanstack/table-core'
import { Link } from 'react-router-dom'
import { mapVendorsToIcons } from '../../../lib/utils/mapVendorsToLogos'
import { VENDOR } from '../../../lib/utils/vendors'
import { useTranslation } from 'react-i18next'

const columnHelper = createColumnHelper<Integration>()

const AdminIntegrations = (): JSX.Element => {
  const [filters, setFilters] = useState<Partial<Integration>>({})
  const filtersPortalNode = useMemo(() => portals.createHtmlPortalNode(), [])
  const { t } = useTranslation('routes')

  const columns = useMemo(
    () => [
      columnHelper.accessor('organization_name', {
        header: () => 'Name',
        enableSorting: false,
        cell: ({ row }) => (
          <Link
            to={t('agency.profile.overview', { agency_id: row.original.organization_id })}
            className="text-primary-persian-blue font-bold">
            {row.original.organization_name}
          </Link>
        ),
      }),
      columnHelper.accessor('vendors', {
        header: () => 'Vendors',
        enableSorting: false,
        cell: ({ row }) => {
          return (
            <div className="flex flex-row items-center gap-2">
              {Object.entries(
                row.original.vendors.reduce((acc, cur) => {
                  const vendor = VENDOR[cur]
                  if (Object.keys(acc).includes(vendor))
                    return { ...acc, [vendor]: acc[vendor] + 1 }
                  else return { ...acc, [vendor]: 1 }
                }, {}),
              ).map(([k, v]) => {
                return (
                  <div key={k} className="flex relative h-[40px] w-[40px]">
                    {mapVendorsToIcons([k])}
                    <span
                      className={
                        'absolute flex justify-center font-Spartan font-bold -bottom-1 -right-2 bg-white border-2 rounded-full w-4 h-4 border-black text-[9px]'
                      }>
                      {v as string}
                    </span>
                  </div>
                )
              })}
            </div>
          )
        },
      }),
    ],
    [t],
  )
  return (
    <motion.div className={'flex flex-1 flex-col pb-8 font-Spartan'}>
      <div className="flex justify-between">
        <div className="flex flex-row items-center gap-1">
          <span className="font-bold text-base">Integrations by Agency</span>
          <Info message={'Only integrations ran witin the last month (30 days)'} />
        </div>
        <portals.OutPortal node={filtersPortalNode} />
      </div>
      <FiltersContext portalNode={filtersPortalNode} setFilters={setFilters}>
        <RadioInput
          name={'vendors'}
          label={'Vendors'}
          options={[
            { label: 'All', value: '10,12,13,14,16,17,18' },
            { label: 'Elead', value: '10' },
            { label: 'DealerVault', value: '12' },
            { label: 'VinSolutions', value: '13' },
            { label: 'CDK', value: '14' },
            { label: 'DealerSocket', value: '16' },
            { label: 'Tekion', value: '17' },
            { label: 'DriveCentric', value: '18' },
          ]}
        />
      </FiltersContext>
      <div className="pt-2">
        <Table columns={columns} filters={filters} fetchFn={useGetIntegrations} />
      </div>
    </motion.div>
  )
}

export default AdminIntegrations
